module.exports = __webpack_public_path__ + "static/media/pretty-social.2f04eee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/headers/pretty-social.png
// module id = 461
// module chunks = 0